import http from '@/http'

const API = {
  operationUser: '/operation/v1/users/search', // 系统账号列表 post
  updateUsersInfo: '/operation/v1/users', // 用户修改修改 post put
  userTypes: '/operation/v1/users/types', // 用户职能类型 get
  getUserInfo: '/login/v1/tokens/users', // 登陆用户信息 get
  getSysUserInfo: '/operation/v1/users/{id}', // 单个用户信息 get
  updateUsersStatus: '/operation/v1/users/{id}', // 停用启用用户 put
  resetPassword: '/operation/v1/users/{id}/password', // 重置密码 delete
  updatePassword: '/user/v1/employees/change/password', // 修改密码 put

  operationRoles: '/operation/v1/roles/search', // 查询角色信息列表 post
  getSysRolesInfo: '/operation/v1/roles/{id}', // 查询单个角色信息
  getRolesResources: '/operation/v1/roles/{id}/resources', // 角色所属权限
  updateRolesInfo: '/operation/v1/roles-resources', // 更新角色信息
  updateRolesStatus: '/operation/v1/roles/{id}/status', // 角色更新角色状态
  rolesUser: '/operation/v1/roles/{id}/users', // 查询角色分配的用户
  deleteRolesUser: '/operation/v1/roles/{id}/users/{userId}', // 移除角色分配的用户

  resourcesSearch: '/operation/v1/resources/search', // 查询菜单管理列表
  shuJuResourcesSearch: '/operation/v1/data-resources/search', // 查询数据权限列表
  getResourcesTree: '/uaa/v1/resources/tree', // 查询用户所属权限
  resourcesSorts: '/operation/v1/resources/sorts', // 菜单管理列表排序
  getResourcesInfo: '/operation/v1/resources/{id}', // 单个资源信息
  updateResourcesInfo: '/operation/v1/resources', // 更新菜单信息
  deleteResources: '/operation/v1/resources/{id}', // 删除菜单

  listLogSearch: '/operation/v1/logs/search', // 系统日志列表
  refreshResource: '/login/v1/confirm/refreshResource', // 刷新token
}

/**
 * 系统账号列表
 * @param options
 * @returns {*}
 */
export function operationUser(options) {
  return http.post({
    ...options,
    url: API.operationUser,
  })
}
/**
 * 更新用户信息
 * @param options
 * @returns {*}
 */
export function updateUsersInfo(options) {
  // console.log(options)

  const {
    data: { id },
  } = options
  let url = !id ? 'post' : 'put'
  return http[url]({
    ...options,
    url: API.updateUsersInfo,
  })
}
/**
 * 账号信息
 * @param options
 * @returns {*}
 */
export function getSysUserInfo(options) {
  const {
    params: { id },
  } = options
  return http.get({
    ...options,
    url: `/operation/v1/users/${id}`,
  })
}

/**
 * 停用启用用户
 * @param options
 * @returns {*}
 */
export function updateUsersStatus(options) {
  return http.put({
    ...options,
    url: `/operation/v1/users/${options.data.id}/status`,
  })
}

/**
 * 重置密码
 * @param options
 * @returns {*}
 */
export function resetPassword(options) {
  const {
    data: { id },
  } = options
  return http.delete({
    ...options,
    url: `/operation/v1/users/${id}/password`,
  })
}

/**
 * 修改密码
 * @param options
 * @returns {*}
 */
export function updatePassword(options) {
  const {
    data: { id },
  } = options
  return http.put({
    ...options,
    url: `/operation/v1/users/password`,
  })
}

/**
 * 查询菜单管理列表
 * @param options
 * @returns {*}
 */
export function resourcesSearch(options) {
  return http.post({
    ...options,
    url: API.resourcesSearch,
  })
}

/**
 * 查询数据权限列表
 * @param options
 * @returns {*}
 */
export function shuJuResourcesSearch(options) {
  return http.post({
    ...options,
    url: API.shuJuResourcesSearch,
  })
}

/**
 * 查询菜单用户所属权限
 * @param options
 * @returns {*}
 */
export function getResourcesTree(options) {
  return http.get({
    ...options,
    url: API.getResourcesTree,
  })
}

/**
 * 查询用户信息
 * @param options
 * @returns {*}
 */
export function getUserInfo(options) {
  return http.get({
    ...options,
    url: API.getUserInfo,
  })
}

/**
 * 菜单管理列表-排序
 * @param options
 * @returns {*}
 */
export function resourcesSorts(options) {
  return http.put({
    ...options,
    url: API.resourcesSorts,
  })
}

/**
 * 单个资源信息
 * @param options
 * @returns {*}
 */
export function getResourcesInfo(options) {
  const {
    params: { id },
  } = options
  return http.get({
    ...options,
    url: `/operation/v1/resources/${id}`,
  })
}
/**
 * 更新菜单信息
 * @param options
 * @returns {*}
 */
export function updateResourcesInfo(options) {
  // console.log(options)

  const {
    data: { id },
  } = options
  let url = !id ? 'post' : 'put'
  return http[url]({
    ...options,
    url: API.updateResourcesInfo,
  })
}

/**
 * 删除资源
 * @param options
 * @returns {*}
 */
export function deleteResources(options) {
  const {
    data: { id },
  } = options
  return http.delete({
    ...options,
    url: `/operation/v1/resources/${id}`,
  })
}

/**
 * 角色列表
 * @param options
 * @returns {*}
 */
export function operationRoles(options) {
  return http.post({
    ...options,
    url: API.operationRoles,
  })
}

/**
 * 更新用户信息
 * @param options
 * @returns {*}
 */
export function updateRolesInfo(options) {
  const {
    data: { id },
  } = options
  let url = !id ? 'post' : 'put'
  return http[url]({
    ...options,
    url: API.updateRolesInfo,
  })
}

/**
 * 角色信息
 * @param options
 * @returns {*}
 */
export function getSysRolesInfo(options) {
  const {
    params: { id },
  } = options
  return http.get({
    ...options,
    url: `/operation/v1/roles/${id}`,
  })
}

/**
 * 角色权限信息
 * @param options
 * @returns {*}
 */
export function getSysRolesResources(options) {
  const {
    params: { id },
  } = options
  return http.get({
    ...options,
    url: `/operation/v1/roles/${id}/resources`,
  })
}

/**
 * 查看分配角色列表
 * @param options
 * @returns {*}
 */
export function rolesUser(options) {
  const {
    params: { id },
  } = options
  return http.get({
    ...options,
    url: `/operation/v1/roles/${id}/users`,
  })
}

/**
 * 停用启用角色
 * @param options
 * @returns {*}
 */
export function updateRolesStatus(options) {
  const {
    data: { id },
  } = options
  return http.put({
    ...options,
    url: `/operation/v1/roles/${id}/status/`,
  })
}

/**
 * 移除角色分配用户
 * @param options
 * @returns {*}
 */
export function deleteRolesUser(options) {
  const {
    data: { id, userId },
  } = options
  return http.delete({
    ...options,
    url: `/operation/v1/roles/${id}/users/${userId}`,
  })
}

/**
 * 日志列表
 * @param options
 * @returns {*}
 */
export function listLogSearch(options) {
  return http.post({
    ...options,
    url: API.listLogSearch,
  })
}

// 获取权限字段
export function querySensitiveAuth(options) {
  return http.get({
    ...options,
    url: '/uaa/v1/querySensitiveAuth',
  })
}
export function refreshResource(options) {
  return http.get({
    ...options,
    url: API.refreshResource,
  })
}

/**
 * 查找登录用户数据权限时间范围
 * https://app.apifox.com/project/2061595/apis/api-111488824

  销售订单流水	orderList
  采购出入库流水	purchaseList
  客户列表	listCustomer
  供应商列表	listSupplier
  首页经营概况	firstPageData
  销售订货流水	orderPlanList
  店铺收支流水	storePayment

  时间范围:1:全部 2:今天 3:近一个月 4:近3个月 5:近6个月 6:近一年
 */
export function getTimeRangePermissions(options) {
  return http.get({
    ...options,
    url: '/user/v1/timeRangePermissions/selections',
  })
}

// http://192.168.4.60:3000/project/278/interface/api/122336
export function getSwitchTenantList(options) {
  return http.get({
    ...options,
    url: '/user/v1/employees/switchTenantList',
  })
}

// http://192.168.4.60:3000/project/71/interface/api/121825
export function getSwitchTenant(options) {
  return http.post({
    ...options,
    url: '/login/v1/switchTenant',
  })
}
export function getRetainDays(options) {
  return http.get({
    ...options,
    url: '/user/v1/tenants/service/retainDays',
  })
}

export default API
